import {Box, Rating, Typography} from '@mui/material';
import {Timer} from '@mui/icons-material';

// Importiere die Quiz-Bilder
import exampleQuiz from '../../img/quiz/example-quiz.jpg';
import deutschlandQuiz from '../../img/quiz/deutschland-quiz.jpg';
import fortniteQuiz from '../../img/quiz/fortnite-battle-royale-quiz.jpg';
import harryPotterQuiz from '../../img/quiz/harry-potter-quiz.jpg';
import internetMemeQuiz from '../../img/quiz/internet-meme-quiz.jpg';
import kurioseFaktenQuiz from '../../img/quiz/kuriose-fakten-quiz.jpg';
import marvelSuperheldenQuiz from '../../img/quiz/marvel-superhelden-quiz.jpg';
import pixarFilmquiz from '../../img/quiz/pixar-filmquiz.jpg';
import skibidiToiletQuiz from '../../img/quiz/skibidi-toilet-quiz.jpg';

export default function QuizInfo({ quiz }) {
  const getQuizImage = (quizId) => {
    switch (quizId) {
      case 'example-quiz': return exampleQuiz;
      case 'deutschland-quiz': return deutschlandQuiz;
      case 'fortnite-battle-royale-quiz': return fortniteQuiz;
      case 'harry-potter-quiz': return harryPotterQuiz;
      case 'internet-meme-quiz': return internetMemeQuiz;
      case 'kuriose-fakten-quiz': return kurioseFaktenQuiz;
      case 'marvel-superhelden-quiz': return marvelSuperheldenQuiz;
      case 'pixar-filmquiz': return pixarFilmquiz;
      case 'skibidi-toilet-quiz': return skibidiToiletQuiz;
      default: return exampleQuiz;
    }
  };

  return (
    <Box className="quiz-info-mini">
      <img src={getQuizImage(quiz.id)} alt={quiz.title} />
      <Box className="quiz-info-difficulty" style={{
        background: quiz.difficulty === 'easy' ? 'rgba(46, 125, 50, 0.95)' :
                   quiz.difficulty === 'medium' ? 'rgba(237, 108, 2, 0.95)' :
                   'rgba(211, 47, 47, 0.95)'
      }}>
        {quiz.difficulty === 'easy' ? 'Leicht' :
         quiz.difficulty === 'medium' ? 'Mittel' :
         quiz.difficulty === 'hard' ? 'Schwer' : 
         quiz.difficulty || 'Nicht angegeben'}
      </Box>
      <Box className="quiz-info-content">
        <Typography variant="h6">{quiz.title}</Typography>
        <Box className="quiz-info-stats">
          <Box className="quiz-info-rating">
            <Rating value={quiz.stats?.averageRating || 0} readOnly size="small" />
            <Typography variant="body2" sx={{ color: 'white', opacity: 0.8 }}>
              ({quiz.stats?.totalRatings || 0})
            </Typography>
          </Box>
          <Box className="quiz-info-questions">
            <Timer sx={{ fontSize: '1.1rem', opacity: 0.8 }} />
            <Typography variant="body2" sx={{ color: 'white', opacity: 0.8 }}>
              {quiz.questions?.length || 0} Fragen
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
} 